import React from 'react';
import { ArtistSearch } from '../components/ArtistSearch';

const SearchPage: React.FC = () => {
  return (
    <div style={{ padding: '32px 20px', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <h1 style={{ color: '#1DB954', marginBottom: '8px', textAlign: 'center' }}>Setlist Search</h1>
      <p style={{ color: '#666', textAlign: 'center', marginBottom: '32px' }}>
        Search for any artist to see their recent setlists
      </p>
      <ArtistSearch onArtistSelect={() => {}} />
    </div>
  );
};

export default SearchPage;
